module.exports = __webpack_public_path__ + "img/doctor.342f6568.svg";